import { SxProps, Typography } from "@outschool/backpack";
import { onlineClassesPath } from "@outschool/routes";
import { useLinkComponent } from "@outschool/ui-utils";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React, { MouseEvent, ReactNode } from "react";

interface OnlineClassesPageLinkProps {
  pageSlug?: string;
  pageName?: string;
  pageBasePath?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent) => void;
  trackingName?: string;
  trackingUniqueId?: string;
  sx?: SxProps;
}

const OnlineClassesPageLink = React.forwardRef<
  HTMLElement,
  OnlineClassesPageLinkProps
>(
  (
    {
      pageSlug,
      pageName,
      pageBasePath,
      children,
      onClick,
      trackingName = "online_classes_link",
      sx,
    },
    ref,
  ) => {
    const Link = useLinkComponent();
    const to = onlineClassesPath(pageSlug || pageName, pageBasePath);
    const trackingUniqueId = to.split("/")[1] || "/";
    return (
      <Link ref={ref} {...{ to, onClick, trackingName, trackingUniqueId }}>
        <Typography
          variant="inherit"
          sx={[
            {
              fontSize: "0.875em",
            },
            ...(Array.isArray(sx) ? sx : [sx]),
          ]}
        >
          {children}
        </Typography>
      </Link>
    );
  },
);

export default OnlineClassesPageLink;
